import React, { useEffect } from 'react'
import { Container, Row, Col, Card, CardBody } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { getSchools } from '../../actions/school'
import { getReports } from '../../actions/report'
import { userLogin } from '../../actions/user'

export default function Index(props) {

  const {schoolid, reportid, studentid} = useParams()
  const dispatch = useDispatch()
  const nav = useNavigate()
  const uri = useLocation().pathname
  const schid = schoolid / (2 * 13 * 13 * 13)
  const mid = studentid / (2 * 13 * 13 * 13 * 13 * 13)

  const {isAuthenticated} = useSelector(state=>state.userReducer)

  const onFinish = () => {
    let fd = new FormData()
    fd.append('admission_no', studentid);
    fd.append('passwd', schoolid);
    fd.append('cat', 'logindirect');
    fd.append('table', 'students');
    dispatch(userLogin(fd))  
  };

useEffect(() => onFinish(), [])

useEffect(() => {
  if(schid > 0){
    let params = {
      data:JSON.stringify(
      {
        'schoolid': schid,
        'studentid': mid
      }),
      cat:'select_result',
      table:'schools',
      narration:'get student records'
    }
   dispatch(getReports(params))
  }
}, [schid])


if(isAuthenticated === true)
{
  nav(`/online/${schoolid}/${reportid}/${studentid}/report`)
}else{
      
}


  return (
    <Container fluid style={{backgroundColor:'gray', margin:'0px', padding:'0px'}}>
      <Row  style={{width:"70%", margin:'auto', backgroundColor:'white', minHeight:'100vh'}}>
        <Col style={{margin:'auto' , minHeight:'100vh' }}>
          <Card style={{ margin:'auto', height:'30em', width:'50%', textAlign:'center' }}>
           {isAuthenticated ? 
           <CardBody>
           <a 
            href={`./online/${schoolid}/${reportid}/${studentid}/report`}>
             <h2>LOOGEED IN ....CLICK HERE TO REDIRECT</h2>
          </a>
         </CardBody>
           :<CardBody>
              <h2>LOGIN IN.. PLEASE WAIT</h2>
            </CardBody>}
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
